import Vue from "vue";
import VueRouter from "vue-router";
import config from "../../vue.config";

import Apertura from "../components/Apertura";
import ContactPage from "../components/ContactPage.vue";
import ProductEditor from "../components/ProductEditor";

Vue.use(VueRouter);

export default new VueRouter({
   // https://router.vuejs.org/guide/essentials/history-mode.html#example-server-configurations
   base: config.publicPath,
   mode: "history",
   routes: [
      { name: "table", path: '/', component: Apertura},
      { name: "contact", path: '/contact', component: ContactPage},
      { name: "editor",  path: "/model/:slug", component: ProductEditor },
      { path: "*", redirect: "/" }
   ],

    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }


})